import { render, staticRenderFns } from "./SwitchButtons.vue?vue&type=template&id=750f2e71"
import script from "./SwitchButtons.vue?vue&type=script&lang=js"
export * from "./SwitchButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports